import { render } from "./UserMenu.vue?vue&type=template&id=76829108&scoped=true&ts=true"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"

import "./UserMenu.vue?vue&type=style&index=0&id=76829108&lang=scss&scoped=true"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76829108"]])

export default __exports__